<template>
  <Drawer
    :title="modalTitle"
    v-model="modalVisible"
    :mask-closable="false"
    :width="650"
    :styles="{ top: '30px' }"
  >
    <Form
      ref="userForm"
      :model="userForm"
      :label-width="70"
      :rules="userFormValidate"
    >
      <FormItem label="姓名" prop="userName">
        <Input v-model="userForm.userName" autocomplete="off" />
      </FormItem>
      <FormItem label="邮箱" prop="email">
        <Input v-model="userForm.email" />
      </FormItem>
      <FormItem label="手机" prop="mobile">
        <Input v-model="userForm.mobile" />
      </FormItem>
      <FormItem label="简介" prop="content">
        <div ref="editor"></div>
      </FormItem>
      <FormItem label="性别" prop="sex">
        <RadioGroup v-model="userForm.sex">
          <Radio :label="1">男</Radio>
          <Radio :label="0">女</Radio>
        </RadioGroup>
      </FormItem>
      <!-- <Form-item label="头像" prop="avatar">
                <Poptip trigger="hover" title="图片预览" placement="right" width="350">
                    <Input v-model="userForm.avatar" placeholder="可直接填入网络图片链接" clearable/>
                    <div slot="content">
                        <img :src="userForm.avatar" alt="无效的图片链接" style="width: 100%;margin: 0 auto;display: block;">
                        <a @click="viewPic()" style="margin-top:5px;text-align:right;display:block">查看原图</a>
                    </div>
                </Poptip>
                <Upload action="/xboot/upload/file"
                        :headers="accessToken"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :format="['jpg','jpeg','png','gif']"
                        :max-size="5120"
                        :on-format-error="handleFormatError"
                        :on-exceeded-size="handleMaxSize"
                        :before-upload="beforeUpload"
                        ref="up"
                        class="upload">
                    <Button icon="ios-cloud-upload-outline">上传图片</Button>
                </Upload>
            </Form-item>-->

      <FormItem label="头像" prop="avatar">
        <upload-input
          :fileUrl="userForm.avatar"
          @on-change="handleUpload"
          width="400px"
          ref="upload"
        ></upload-input>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button type="text" @click="cancelUser">取消</Button>
      <Button type="primary" :loading="submitLoading" @click="submitUser"
        >提交</Button
      >
    </div>
  </Drawer>
</template>

<script>
import { uploadFile } from "@/api/index";
import { addLecturer, editLecturer, getLecturer } from "@/api/lecturer";
import uploadInput from "@/views/my-components/flyme/upload-input";
import E from "wangeditor";

export default {
  name: "lecturerModule",
  components: {
    uploadInput,
  },
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("密码长度不得小于6位"));
      } else {
        callback();
      }
    };
    const validateMobile = (rule, value, callback) => {
      var reg = /^[1][3,4,5,6,7,8][0-9]{9}$/;
      if (!reg.test(value)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };
    return {
      accessToken: {},
      modalType: 0,
      errorPass: "",
      deptLoading: false,
      modalTitle: "",
      dataDep: [],
      userRoles: [],
      roleList: [],
      submitLoading: false,
      modalVisible: false,
      userForm: {
        sex: 1,
        userType: "UT_LECTURER",
        avatar: "https://s1.ax1x.com/2018/05/19/CcdVQP.png",
        roleIds: [],
        departmentId: "",
        deptName: "",
        email: "",
      },
      userFormValidate: {
        userName: [
          { required: true, message: "账号不能为空", trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          { validator: validateMobile, trigger: "blur" },
        ],
        email: [
          { required: false, message: "请输入邮箱地址" },
          { type: "email", message: "邮箱格式不正确" },
        ],
      },
      showHTMLModal: false, // 显示html
    };
  },
  methods: {
    init() {
      this.accessToken = {
        accessToken: this.getStore("accessToken"),
      };
      this.getParentList();
      this.initEditor();
    },
    initEditor() {
      let that = this;
      editor = new E(this.$refs.editor);
      let editorConfig = editor.customConfig
        ? editor.customConfig
        : editor.config;
      editorConfig.onchange = (html) => {
        this.form.messageContent = xss(html);
      };
      editorConfig.uploadImgServer = uploadFile;
      editorConfig.uploadImgHeaders = {
        Authorization: that.getStore("accessToken"),
      };
      editorConfig.uploadFileName = "file";
      editorConfig.uploadImgHooks = {
        before: function (xhr, editor, files) {},
        success: function (xhr, editor, result) {},
        fail: function (xhr, editor, result) {
          that.$Message.error("上传图片失败");
        },
        error: function (xhr, editor) {
          that.$Message.error("上传图片出错");
        },
        timeout: function (xhr, editor) {
          that.$Message.error("上传图片超时");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.status === true) {
            let url = result.data.fileUrl;
            insertImg(url);
            that.$Message.success("上传图片成功");
          } else {
            that.$Message.error(result.info);
          }
        },
      };
      editorConfig.fontNames = ["微软雅黑", "宋体", "黑体", "Arial"];
      editorConfig.emotions = [
        {
          title: "新浪",
          type: "image",
          content: sina,
        },
      ];
      editor.create();
    },
    editHTML() {
      this.dataEdit = this.form.messageContent;
      this.showHTMLModal = true;
    },
    editHTMLOk() {
      editor.txt.html(this.dataEdit);
      this.form.messageContent = xss(this.dataEdit);
      this.showHTMLModal = false;
    },
    //添加-部门选择初始化
    getParentList() {
      initDepartment().then((res) => {
        if (res.status === true) {
          this.dataDep = res.data;
        }
      });
    },
    add() {
      this.modalTitle = "添加讲师";
      this.$refs.userForm.resetFields();
      this.modalVisible = true;
    },
    edit(row) {
      this.modalTitle = "编辑讲师";
      this.modalVisible = true;
      this.modalType = 1;
      getLecturer(row.id).then((res) => {
        this.loading = false;
        if (res.status === true) {
          this.userForm = res.data;
        }
      });
    },
    cancelUser() {
      this.modalVisible = false;
    },
    viewPic() {
      this.viewImage = true;
    },
    clearSelectDep() {
      this.userForm.departmentId = "";
      this.userForm.deptName = "";
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "不支持的文件格式",
        desc:
          "所选文件‘ " +
          file.name +
          " ’格式不正确, 请选择 .jpg .jpeg .png .gif格式文件",
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "文件大小过大",
        desc: "所选文件‘ " + file.name + " ’大小过大, 不得超过 5M.",
      });
    },
    beforeUpload() {
      if (!this.$route.meta.permTypes.includes("upload")) {
        this.$Message.error("此处您没有上传权限(为演示功能，该按钮未配置隐藏)");
        return false;
      }
      return true;
    },
    handleSuccess(res, file) {
      if (res.success === true) {
        file.url = res.result;
        this.userForm.avatar = res.result;
      } else {
        this.$Message.error(res.message);
      }
    },
    handleError(error, file, fileList) {
      this.$Message.error(error.toString());
    },
    handleUpload(v) {
      this.userForm.avatar = v.fileUrl;
    },
    selectTree(v) {
      if (v.length > 0) {
        // 转换null为""
        for (let attr in v[0]) {
          if (v[0][attr] === null) {
            v[0][attr] = "";
          }
        }
        let data = JSON.parse(JSON.stringify(v[0]));
        this.userForm.departmentId = data.value;
        this.userForm.deptName = data.label;
      }
    },
    submitUser() {
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          if (this.modalType === 0) {
            // 添加用户 避免编辑后传入id
            delete this.userForm.id;
            delete this.userForm.status;
            this.submitLoading = true;
            addLecturer(this.userForm).then((res) => {
              this.submitLoading = false;
              if (res.status === true) {
                this.$Message.success("添加成功");
                this.$parent.refreshTable();
                this.modalVisible = false;
              }
            });
          } else {
            // 编辑
            editLecturer(this.userForm).then((res) => {
              this.submitLoading = false;
              if (res.status === true) {
                this.$Message.success("修改成功");
                this.$parent.refreshTable();
                this.modalVisible = false;
              }
            });
          }
        }
      });
    },
    loadDataTree(item, callback) {
      loadDepartment(item.value).then((res) => {
        if (res.status === true) {
          callback(res.data);
        }
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
</style>